import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Button, DropDown, Input } from "../../../components";
import {
  validateAlphabet,
  validateAlphanumericCharacterWithoutSequence,
  validateCharacterLength,
  validatePositiveValue,
} from "../../../utilities/utils";
import { useAppSelector } from "../../../redux/Hooks/Hook";

const CustomerCoachingBookingStep3 = (props: any) => {
  const { data, updateData, handleNext, error } = props;
  const { states } = useAppSelector((state: any) => state.states);

  const setStringValue = (key = "", value = "") => {
    if (validateAlphabet(value)) {
      updateData(key, value);
    }
  };

  const setValueWithLengthAndPositive = (
    key = "",
    value = "",
    min = 0,
    max = 0
  ) => {
    if (
      validateCharacterLength(value, min, max) &&
      validatePositiveValue(value)
    ) {
      updateData(key, value);
    }
  };

  const setAlphanumericValueWithoutSequence = (key = "", value = "") => {
    if (validateAlphanumericCharacterWithoutSequence(value)) {
      updateData(key, value);
    }
  };

  return (
    <>
      <Container fluid className="g-0">
        <Row className="row-mb align-items-center">
          <h4 className="fs-5 fw-semibold mb-4 text-start">
            Additional Information
          </h4>

          <Col lg={4}>
            <div className="mb-3 text-start">
              <label htmlFor="firstName" className="form-label">
                Attendee First Name <small className="text-danger">*</small>
              </label>
              <Input
                type="text"
                placeholder="Enter Attendee First Name"
                id="firstName"
                name="firstName"
                className="form-control"
                value={data?.firstName}
                onChange={(e: any) => updateData("firstName", e.target.value)}

              />
              <span className="error-msg">{error?.firstName}</span>
            </div>
          </Col>
          <Col lg={4}>
            <div className="mb-3 text-start">
              <label htmlFor="lastname" className="form-label">
                Attendee Last Name <small className="text-danger">*</small>
              </label>
              <Input
                type="text"
                placeholder="Enter Attendee Last Name"
                id="lastName"
                name="lastName"
                className="form-control"
                value={data?.lastName}
                onChange={(e: any) => updateData("lastName", e.target.value)}

              />
              <span className="error-msg">{error?.lastName}</span>
            </div>
          </Col>

          <Col lg={4}>
            <div className="mb-3 text-start">
              <label htmlFor="school-name" className="form-label">
                Email <small className="text-danger">*</small>
              </label>
              <Input
                type="email"
                placeholder="Enter Email Address"
                id="email"
                name="email"
                required={true}
                className="form-control"
                value={data?.email}
                disabled={true}
              />
              <span className="error-msg">{error?.email}</span>
            </div>
          </Col>

          <Col lg={3}>
            <div className="mb-3 text-start">
              <label htmlFor="school-name" className="form-label">
                School Name
              </label>
              <Input
                type="text"
                placeholder="Enter School Name"
                id="schoolname"
                name="schoolname"
                className="form-control"
                value={data?.schoolName}
                onChange={(e: any) => updateData("schoolName", e.target.value)}


              />
              <span className="error-msg">{error?.schoolName}</span>
            </div>
          </Col>
          <Col lg={3}>
            <div className="mb-3 text-start">
              <label htmlFor="parent-name" className="form-label">
                Parent Name
              </label>
              <Input
                type="text"
                placeholder="Enter Parent Name"
                id="parentName"
                name="parentName"
                className="form-control"
                value={data?.parentName}
                onChange={(e: any) => updateData("parentName", e.target.value)}
              />
              <span className="error-msg">{error?.parentName}</span>
            </div>
          </Col>
          <Col lg={3}>
            <div className="mb-3 text-start">
              <label htmlFor="whatsapp-number" className="form-label">
                Whatsapp Number <small className="text-danger">*</small>
              </label>
              <Input
                type="text"
                placeholder="Enter WhatsApp Number"
                id="whatsAppNumber"
                name="whatsAppNumber"
                className="form-control"
                value={data?.whatsAppNumber}
                onChange={(e: any) => {
                  const val = e.target.value;
                  if (/^\d{0,10}$/.test(val)) updateData("whatsAppNumber", val);
                }}
              />
              <span className="error-msg">{error?.whatsAppNumber}</span>
            </div>
          </Col>
          <Col lg={3}>
            <div className="mb-3 text-start">
              <label htmlFor="gender" className="form-label">
                Gender
                {/* <small className="text-danger">*</small> */}
              </label>
              <DropDown
                className="form-control"
                id="gender"
                name="gender"
                value={data?.gender}
                onChange={(e: any) => updateData("gender", e.target.value)}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </DropDown>
              <span className="error-msg">{error?.gender}</span>
            </div>
          </Col>
          <Col lg={3}>
            <div className="mb-3 text-start">
              <label className="form-label">
                Date of Birth <small className="text-danger">*</small>
              </label>
              <Input
                type="date"
                value={data?.birthDate?.split("/").reverse().join("-")}
                formate="dd-mm-yyyy"
                className="form-control"
                id="birthDate"
                name="birthDate"
                onChange={(e: any) => updateData("birthDate", e.target.value)}
                max={new Date().toISOString().split("T")[0]}
              />
              <span className="error-msg">{error?.birthDate}</span>
            </div>
          </Col>
          <Col lg={3}>
            <div className="mb-3 text-start">
              <label htmlFor="aadhar" className="form-label">
                Aadhar Number
              </label>
              <Input
                type="text"
                placeholder="Enter Aadhar Number"
                id="aadharnum"
                name="aadharnum"
                className="form-control"
                value={data?.aadharNumber}
                onChange={(e: any) =>
                  setValueWithLengthAndPositive(
                    "aadharNumber",
                    e.target.value,
                    0,
                    12
                  )
                }
                onKeyDown={(e: any) =>
                  (e.key === "e" || e.key === ".") && e.preventDefault()
                }
              />
            </div>
          </Col>
          <Col lg={3}>
            <div className="mb-3 text-start">
              <label htmlFor="address" className="form-label">
                Address Line 1
                {/* <small className="text-danger">*</small> */}
              </label>
              <Input
                type="text"
                placeholder="Enter Address"
                id="addressLine1"
                name="addressLine1"
                className="form-control"
                value={data?.addressLine1}
                onChange={(e: any) =>
                  setAlphanumericValueWithoutSequence(
                    "addressLine1",
                    e.target.value
                  )
                }
              />
              <span className="error-msg">{error?.addressLine1}</span>
            </div>
          </Col>
          <Col lg={3}>
            <div className="mb-3 text-start">
              <label htmlFor="addressLine2" className="form-label">
                Address Line 2
              </label>
              <Input
                type="text"
                placeholder="Enter Address"
                id="addressLine2"
                name="addressLine2"
                className="form-control"
                value={data?.addressLine2}
                onChange={(e: any) =>
                  setAlphanumericValueWithoutSequence(
                    "addressLine2",
                    e.target.value
                  )
                }
              />
              <span className="error-msg">{error?.addressLine2}</span>
            </div>
          </Col>
          <Col lg={3}>
            <div className="mb-3 text-start">
              <label htmlFor="landmark" className="form-label">
                Landmark
              </label>
              <Input
                type="text"
                placeholder="Enter Address"
                id="landmark"
                name="landmark"
                className="form-control"
                value={data?.landmark}
                onChange={(e: any) =>
                  setAlphanumericValueWithoutSequence(
                    "landmark",
                    e.target.value
                  )
                }
              />
              <span className="error-msg">{error?.landmark}</span>
            </div>
          </Col>

          <Col lg={3}>
            <div className="mb-3 text-start">
              <label htmlFor="pincode" className="form-label">
                Pincode
                {/* <small className="text-danger">*</small> */}
              </label>
              <Input
                type="text"
                placeholder="Enter pincode"
                id="pincode"
                name="pincode"
                className="form-control"
                value={data?.pincode}
                onChange={(e: any) =>
                  setValueWithLengthAndPositive("pincode", e.target.value, 0, 6)
                }
                onKeyDown={(e: any) =>
                  (e.key === "e" || e.key === ".") && e.preventDefault()
                }
              />
              <span className="error-msg">{error?.pincode}</span>
            </div>
          </Col>
          <Col lg={3}>
            <div className="mb-3 text-start">
              <label htmlFor="city" className="form-label">
                City
                {/* <small className="text-danger">*</small> */}
              </label>
              <Input
                type="text"
                placeholder="Enter City"
                id="city"
                name="city"
                className="form-control"
                value={data?.city}
                onChange={(e: any) => setStringValue("city", e.target.value)}
              />
              <span className="error-msg">{error?.city}</span>
            </div>
          </Col>
          <Col lg={3}>
            <div className="mb-3 text-start">
              <label htmlFor="state" className="form-label">
                State
                {/* <small className="text-danger">*</small> */}
              </label>
              <DropDown
                name="state"
                id="state"
                className="form-control"
                value={data?.state}
                onChange={(e: any) => updateData("state", e.target.value)}
              >
                <option value="">Select State</option>
                {states?.map((item: any) => {
                  return (
                    <option key={item.code} value={item.name}>
                      {item.name}
                    </option>
                  );
                })}
              </DropDown>
              <span className="error-msg">{error?.state}</span>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col lg={12} className="text-end">
            <Button
              onClick={handleNext}
              type="button"
              bname="Confirm"
              name="confirm"
              id="confirm"
              className="btn btn-primary rounded-1"
            ></Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export { CustomerCoachingBookingStep3 };
